import { ReactNode } from "react";

import { ArrowLeft } from "@hagerty/icons";
import { unstable__Button as Button } from "@hagerty/react-components";

import { routes } from "../../routing/routes";
import styles from "./Layout.module.scss";
import appstyles from "../../app/App.module.scss";

export type LayoutProps = {
  children?: ReactNode;
  title?: string;
  subtitle?: string;
  hasBreadcrumb?: boolean;
};

export const Layout = ({
  title,
  subtitle,
  children,
  hasBreadcrumb = true,
}: LayoutProps) => {
  return (
    <div className={appstyles.container}>
      <div className="container container_center">
        <div className={styles.column}>
          {hasBreadcrumb && (
            <Button
              className={styles.breadcrumb}
              variant="text"
              size="small"
              href={routes.main}
              iconLeft={{ icon: ArrowLeft }}
            >
              Account home
            </Button>
          )}
          {title && <h2 className={styles.title}>{title}</h2>}
          {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
          {children}
        </div>
      </div>
    </div>
  );
};
